<script lang="ts" setup>
import type { LayoutRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ data: LayoutRecord }>();
</script>

<template>
  <div v-if="data" class="flex flex-col items-center lg:flex-row lg:items-start lg:justify-between">
    <div>
      {{ data.footerSubtitle }}
      <!-- <a href="https://alistar.net/e-commerce" target="_blank" rel="noopener" class="underline">
        E-business by Alistar.
      </a> -->
    </div>

    <div class="my-3 lg:my-0">
      <ul>
        <li v-for="footerLink in data.footerLinks" :key="footerLink.id" class="me-2 inline underline">
          <NuxtLinkLocale :to="`/legal/${footerLink.slug}`">
            {{ footerLink.title }}
          </NuxtLinkLocale>
        </li>
      </ul>
    </div>

    <FooterSocialMediaLinks :social-media-links="data.socialMediaLinks" />
  </div>
</template>

<style scoped>

</style>
